export const home = [
    {
        id: "content-frontpage-breaking-news",
        name: "أخبار عاجلة",
        articles: [
            {
                id: "8a6ed5ec-89f3-42ad-b948-189d36f278c9",
                class: "columns-3-narrow",
                header: "غير خاضعة للرقابة",
                url: "#",
                image: {
                    src: "assets/images/isai-ramos-Sp70YIWtuM8-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الاستهداف الآن ، موز الحياة الحلق للغاية.",
                type: "text",
                content:
                    "الرجاء أعضاء كرة القدم كقوة كرة قدم.لكن الوقت هو جرة وجع.مجموعة غير من الفلفل الحار.عنصر الحياة الآن ولكن أعضاء كرة القدم في الهواء الطلق.في أي رعاية لسهم سريري.آخر ما تريد دعاية مطوري كرة القدم البيئية السلطة في بعض الأحيان.الاستهداف الآن ، موز الحياة الحلق للغاية أو .الآن مسح الحياة في الحلق.\n\nبشكل السفن ما يتم. جدول الإمداد أن جُل, هو دون اتفاقية باستحداث الدولارات. فقد في وشعار الأمريكي. اكتوبر بتطويق ليرتفع الى قد, غير بالرغم أفريقيا إستيلاء في. وحرمان باستخدام و لها, أن يعبأ بمباركة ولم, ان ومضى الجوي تحرّك حول.",
            },
            {
                id: "d204d10c-879e-4991-802c-25020077e0de",
                class: "columns-3-wide",
                header: "المزيد من القصص العليا",
                url: "#",
                image: {
                    src: "assets/images/nasa-dCgbRAQmTQA-unsplash_684.jpg",
                    alt: "عنصر نائب",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                    tag: {
                        type: "breaking",
                        label: "كسر",
                    },
                },
                title: "فقط بحاجة إلى كرة قدم رائعة لأعمال الاحماء ، ولا تتغذى على القطر.",
                type: "text",
                content:
                    "لان وتنصيب والفلبين التبرعات إذ. المواد وهولندا، إذ كلّ, دار السيطرة والكساد لم. عدد لم اللا الثالث استعملت, ذات من ويتّفق معاملة. قائمة معارضة قبل ما. قد الجو وهولندا، فقد. أخذ إذ كانتا وبالرغم, يبق هو مرجع ليركز ويكيبيديا،. جُل الفترة الأرواح ثم, بشكل وصغار غير بل, قام عل وباءت المسرح الجنوبي.\n\nتعد وجهان ميناء غينيا مع, و تجهيز وقدّموا فقد. المسرح الأرواح إذ ضرب, و تلك تسمّى وقامت الأهداف. أسر ثم وسمّيت وتتحمّل الانجليزية. بل قدما حالية مكن, الآلاف المتحدة مع به،. فكانت يعادل أن بلا, تكبّد لتقليعة بريطانيا-فرنسا كان قد.",
            },
            {
                id: "e02d07e1-32e3-4ad1-b57c-b945f89d12d3",
                class: "columns-3-narrow",
                header: "الجريمة والعدالة",
                url: "#",
                video: {
                    id: "1992-153555258",
                    src: "assets/videos/1992-153555258_tiny.mp4",
                    width: "640",
                    height: "360",
                    type: "HTML5 Video",
                    origin: "https://pixabay.com/videos/world-globe-international-global-1992/"
                },
                meta: {
                    captions: "فيديو من شخص ما.",
                },
                title: "سلطة كرة القدم حياة مجرد عملية الاحماء العظيمة.",
                type: "text",
                content:
                    "هذا و كانتا مليارات الفرنسي, وبداية وبعدما فعل و. مليون وحرمان مما لم, الا مع تكبّد سبتمبر, جنوب قِبل إجلاء بـ عرض. إبّان مكثّفة واقتصار بعد أن, و ذلك غينيا تكتيكاً. ان أسر أفاق تعداد المسرح, و ببعض لتقليعة لان. في جُل بحشد الدّفاع, بل لهيمنة وتتحمّل بحث. عل وشعار أمدها قتيل، بين, تحت ان أجزاء وقامت المتحدة, دار إختار الأول أي. بـ أدنى وسمّيت الفرنسية شيء.\n\nولم واندونيسيا، تشيكوسلوفاكيا تم, ما ولم إنطلاق العالم الأثنان, وصل عالمية مشاركة الأوروبية، و. أي دأبوا الطريق الأثناء، حين. وانهاء مساعدة ومن ان, قبل و معارضة ألمانيا. به، مئات وباءت الربيع، في, دون اتّجة كُلفة الجنوب تم. أن هذه عليها اكتوبر العالمي. بحشد فبعد الدمج يبق من, ٣٠ أكثر ولاتّساع كان.",
            },
        ],
    },
    {
        id: "content-frontpage-latest-news",
        name: "أحدث الأخبار",
        articles: [
            {
                id: "7af9e63d-d803-477b-ba8f-539f5d7ed1fe",
                class: "columns-3-balanced",
                header: "يحدث الآن",
                type: "articles-list",
                content: [
                    {
                        id: "45114281-a2ad-4ed8-bb47-80526e802eb1",
                        title: "لوريم الجزر جدا.",
                        content:
                            "كانتا فرنسية استبدال أم فصل, أخر إذ الأراضي باستحداث. تلك أن استبدال لبلجيكا،, كل لكل وسوء الوزراء, وقام وجهان مساعدة وصل كل. كل فكان سياسة أساسي بعض, حيث أم الأخذ الشمل العسكري, ولم في هناك الآلاف. الا السبب الصفحات أم, لم خلاف ٢٠٠٤ عرض. للمجهود الأوربيين بريطانيا-فرنسا بحث قد, حتى لغزو اليها الإقتصادية إذ, وبغطاء الضروري استبدال إذ لكل. و دول دفّة الحرة للجزر, ضرب غرّة، المبرمة ثم, بالرّد البرية الأعمال ٣٠ حيث.",
                    },
                    {
                        id: "ee8b2a9f-a08b-495e-a4ba-21b3b42bf07d",
                        title: "إجراءات المراقبة المحسنة.",
                        content:
                            "تحت وبداية عالمية مسؤولية بل, بشرية نتيجة البولندي عن به،, ومضى الإنزال أسر بل. والكوري الخارجية ما أخذ, ٣٠ للصين أفريقيا ذلك. لكل تم وحتّى بلديهما. بالعمل بتطويق باستحداث أسر إذ. أضف عل الإثنان والفلبين, لدحر بتحدّي وفنلندا وتم ما, والنفيس العمليات الإكتفاء ثم جعل.",
                    },
                    {
                        id: "4a9d6914-983d-48ab-a7ed-d7ed1d877a6b",
                        title: "لكنني سأكون في.",
                        content:
                            "ماذا باستخدام لم أما, مع لمّ بقسوة المشتّتون. يكن أن وعُرفت والإتحاد. ولاتّساع الرئيسية ما ذلك. كلا ترتيب لعملة لم, الضغوط محاولات استراليا، هو ضرب. الأسيوي, محاولات الباهضة واندونيسيا، مع جعل. عن بعد فقامت الخاسر التخطيط. يكن بهيئة أسابيع ولاتّساع",
                    },
                ],
            },
            {
                id: "cb7942ac-5ac8-40d1-90fd-7853a0a10d16",
                class: "columns-3-balanced",
                header: "جدير بالملاحظة",
                image: {
                    src: "assets/images/peter-lawrence-rXZa4ufjoGw-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الدعاية أو الحامل في الاحماء والرعاية والسريرية.",
                type: "list",
                content: [
                    {
                        id: "b5f94d51-7e7c-4e1f-b55d-e99ba9e2398d",
                        content: "معقل الواقعة عن غير, قد ومن صفحة تسمّى الرئيسية.",
                    },
                    {
                        id: "6ce7f58f-429c-4835-a7fc-8f8bd1f3a12e",
                        content: "هو. بعض بقعة قدما عل, جُل دفّة بتخصيص قد. انه تزامناً لتقليعة ٣٠, إذ أثره، أراضي بالجانب فعل, إذ قام الذود مليون البرية.",
                    },
                    {
                        id: "021f9b0b-1666-4d15-a32b-42a464475cc0",
                        content: "عض بقعة قدما عل, جُل دفّة بتخصيص قد. انه تزامناً لتقليعة ٣٠, إذ أثره، أراضي بالجانب فعل, إذ قام الذود مليون",
                    },
                    {
                        id: "bf40e93f-eea6-4f0a-8ad5-1e25cd3b69ab",
                        content: "وتم و بزمام المتّبعة الدولارات, ان أسابيع الثالث، الثقيلة تلك, دول ٣٠ وجزر مشارف الآلاف. شاسعة النفط ولم ٣٠, مما عل رئيس مسؤولية وقدّموا. أن قائمة",
                    },
                ],
            },
            {
                id: "cd53f511-0251-4fb0-ae85-9ad228551dd6",
                class: "columns-3-balanced",
                header: "حول العالم",
                image: {
                    src: "assets/images/rufinochka-XonjCOZZN_w-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الآن فيليس الأرض ، كرة السلة تحتاج إلى كتلة كبيرة ، كارتون لوريه لوريم.",
                type: "list",
                content: [
                    {
                        id: "7e405fe8-7abd-43b7-bbca-2ea2e7b0ac76",
                        content: "الخاصّة حدى, أم شاسعة غرّة، لها. بل وشعار مواقعها أضف, وشعار فرنسية المسرح حين بـ. الى الوزراء الشّعبين كل. بعض هاربر بتخصيص بمباركة بل, عل جُل وقبل قدما مسارح",
                    },
                    {
                        id: "b9dad22b-d7b9-4ca2-9585-c8762a15de9c",
                        content: "أراض بالحرب الحيلولة بعض ثم, هو أسيا ضمنها فعل. قتيل، والنفيس غير بـ, هامش شواطيء الإتحاد ثم حدى, أي قبل هناك الأولى.",
                    },
                    {
                        id: "b87bd7d4-03b1-4107-accc-de86415f1de0",
                        content: "هو الفترة وفرنسا لليابان بحق. الآخر الإنزال ولاتّساع ثم حتى. أخر ما بسبب تصرّف مشاركة, كل حقول بوابة طوكيو ضرب, مرمى وزارة السبب دنو ثم. يعبأ القوى الاندونيسية لم يبق,",
                    },
                    {
                        id: "6c8c8717-7069-4f37-865a-e69c8c01a6ba",
                        content: "بـ أخر غينيا بتخصيص, كلا هو إبّان كنقطة  أن. ما بعض يقوم العالمي المنتصر. واُسدل ولكسمبورغ بـ ضرب, تم الا يعبأ السيطرة, بالرّد محاولات جهة أم.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-latest-media",
        name: "أحدث الوسائط",
        articles: [
            {
                id: "b419e5f0-1707-4c0e-85b3-48f26a70f91b",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "a2ef309b-d8af-4621-9a33-883269394a96",
                        image: {
                            src: "assets/images/steven-van-bTPP3jBnOb8-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "fb3262b1-6618-4d3d-998b-6072104beefa",
                        image: {
                            src: "assets/images/markus-spiske-WUehAgqO5hE-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "ed0edcac-b8f1-43d4-a0a3-fdee2812122e",
                        image: {
                            src: "assets/images/david-everett-strickler-igCBFrMd11I-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "0b55ff73-13ca-43ae-9980-d02d01abd921",
                        image: {
                            src: "assets/images/marco-oriolesi-wqLGlhjr6Og-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-highlights",
        name: "يسلط الضوء",
        articles: [
            {
                id: "1519cdfe-bb32-4f0a-aad1-2f4bb87096a4",
                class: "columns-wrap",
                header: "النقاط البارزة المحلية",
                type: "excerpt",
                content: [
                    {
                        id: "ff2abe6a-3418-473e-80c1-b262188e5554",
                        image: {
                            src: "assets/images/samuel-schroth-hyPt63Df3Dw-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "يبق عن قدما حاملات, وفي عن هناك اعتداء والفلبين. كل تزامناً الجنوبي العالمية عدد, أعلنت بالمحور في دار. وبالرغم أفريقيا ان بال. أمام البولندي تشيكوسلوفاكيا ذلك هو. أساسي وصافرات إيو لم. وصل كردة وصافرات ما.",
                    },
                    {
                        id: "7ea12782-cf94-459d-b7ec-3be5d43175cf",
                        image: {
                            src: "assets/images/denys-nevozhai-7nrsVjvALnA-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بـ مسارح والفلبين التقليدية وتم, لدحر الشرقية الوزراء عدد ثم. كردة وإيطالي الصفحات بل حيث, بـ بحث بقصف مسرح أخرى. مدن الله وأكثرها ومطالبة بل, زهاء سقوط الأولية قد وصل, يقوم الصفحة مكن ٣٠. جديدة اكتوبر ان لها, تم الا بقصف لكون. قد اوروبا الخارجية عرض. بين كل وترك أمّا وسمّيت.",
                    },
                    {
                        id: "0af1cd6a-a044-43b4-8ec8-26b71a0a9ca4",
                        image: {
                            src: "assets/images/mattia-bericchia-xkD79yf4tb8-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "لكل كُلفة حادثة كل, ما أراض حادثة التنازلي به،. الدمج الساحة تم مما, بشرية إعادة قد الى, به، جمعت بمباركة ما. وفي في مارد تمهيد, كلا تم حلّت أمام مدينة, جعل و الأرواح واشتدّت. من وعلى الصفحات حيث. فعل وصغار الشرقية المزيفة أن.",
                    },
                ],
            },
            {
                id: "0b9b6f8c-0dde-4c2f-82dd-b777fa84881d",
                class: "columns-wrap",
                header: "النقاط البارزة العالمية",
                type: "excerpt",
                content: [
                    {
                        id: "c69ff80d-44cf-463a-b3db-bc2f22e8993c",
                        image: {
                            src: "assets/images/maximilian-bungart-nwqfl_HtJjk-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "كلّ أمّا الجو الصينية بل. إذ كما جسيمة اليابان، المتساقطة،, حين أملاً يتمكن ثم, لم تحت ميناء بالرغم. عرض للسيطرة لإنعدام من. ان القوى انتباه الإحتفاظ حيث, لان تم احداث الفترة الخاطفة, أوزار اوروبا والديون أضف ان. في منتصف والفلبين جُل, هذا عل الآخر بالحرب, بقعة مارد وسمّيت أضف ثم. مدينة المتاخمة بريطانيا-فرنسا تحت بل, تم كما بالإنزال بالولايات.",
                    },
                    {
                        id: "24cfa9e5-9a6c-4e00-980a-05a5d583e718",
                        image: {
                            src: "assets/images/gaku-suyama-VyiLZUcdJv0-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "كان إحتار اليها السادس و, تم هذا بوابة التقليدية, الحيلولة المتّبعة الولايات ٣٠ دول. يبق جنوب وقرى والحزب أن, ٣٠ الله دأبوا الضروري عدم, وتم رجوعهم وسمّيت المتساقطة، ٣٠. عل لمّ الدول بتحدّي, عجّل أعلنت ابتدعها تم يتم. ما الأخذ المتساقطة، كما. جنوب أكثر انه هو, عل وبعد وسوء يكن.",
                    },
                    {
                        id: "3bf00e72-8821-446d-8096-1d5d3ea5c8c9",
                        image: {
                            src: "assets/images/paul-bill-HLuPjCa6IYw-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "فعل أي كثيرة والروسية, عن خطّة إحكام فرنسية وصل. هذه ٣٠ إعمار إبّان الانجليزية. مسرح عملية حول أم, كل قِبل سياسة مدينة لكل. تم يبق حقول تاريخ للجزر. أن كانت الأوروبية، بعض, عل بعض هامش لفشل بشرية, غينيا الأحمر السادس أي حدى. إذ وتم ثانية تجهيز, ٠٨٠٤ بقسوة عالمية حين في, بالحرب بأضرار مع كما.",
                    },
                ],
            },
            {
                id: "8eed7659-370e-4a45-8977-b21eb88ab793",
                class: "columns-wrap",
                header: "أبرز الأحداث المحلية",
                type: "excerpt",
                content: [
                    {
                        id: "72522d42-30bf-42f0-ba21-5dbc080dfab1",
                        image: {
                            src: "assets/images/maarten-van-den-heuvel-gZXx8lKAb7Y-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ان لليابان الحكومة يبق. كل أثره، المضي الأهداف كلّ, أما تم غريمه الشمل. أم أهّل اوروبا شموليةً نفس, للصين ارتكبها بال تم. من كان المسرح يتعلّق, العالمي اتفاقية يكن تم. حيث عملية النفط الحدود لم. وأزيز وتزويده أي فعل, ٣٠ ومن احداث يتبقّ الخطّة. الجو تنفّس المتحدة في قام, حول قد سقوط للسيطرة والنرويج.",
                    },
                    {
                        id: "bab8b49c-4e37-4cf8-8c52-714cb53daf5d",
                        image: {
                            src: "assets/images/quino-al-KydWCDJe9s0-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "قبل للمجهود بمباركة ٣٠, ثم ولم الذود الساحة إستيلاء. عدد و بالعمل وبالرغم الكونجرس, هذه المحيط استطاعوا التقليدية ان. دار الشهير وفرنسا بالولايات في. ثم كلا كردة فقامت الفرنسي, تم نفس الأمم الأولى الساحل. تكبّد الصينية وقد بل, ثم إحتار إستعمل التخطيط جهة, ذات أن تنفّس فكانت الشتاء،. الوراء الشرقية ماليزيا، قد فقد, يعبأ مشاركة الإنزال أن بعد.",
                    },
                    {
                        id: "eb3516e6-ad00-4d39-822c-acc4eab9befa",
                        image: {
                            src: "assets/images/mathurin-napoly-matnapo-pIJ34ZrZEEw-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "جهة التنازلي المتساقطة، ان, به، حقول ويتّفق معارضة إذ. أم كلا الخاطفة الشهيرة الأولية. أوروبا المجتمع وقد مع, تاريخ العالمية المشتّتون ما وتم, فسقط شدّت ان دول. يذكر تكبّد من قام. شمال دأبوا الكونجرس ٣٠ مدن, لكل مع شمال لدحر دأبوا. هذا و تعديل تجهيز الوزراء, ما يذكر لغزو دون.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-top-stories",
        name: "أهم الأخبار",
        articles: [
            {
                id: "4e01d65b-b4f0-4b43-8d28-2fb8f918071c",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "2923bc4a-fceb-45e7-bf92-f9e8f9d826ec",
                        image: {
                            src: "assets/images/andrew-solok-LbckXdUVOlY-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "ما عشوائية سنغافورة غير, أي جهة الجنوب ابتدعها, بـ الا بزمام فشكّل يونيو. كل كان أمام وأزيز الحيلولة, دفّة الإمتعاض واندونيسيا، وتم ان. الأرض الحكومة المعاهدات مع أخذ. قد لفشل ابتدعها لان, لم يكن واعتلاء وبلجيكا،. في فعل يطول أسيا وأزيز, ان تعديل وزارة هذه.",
                        url: "#",
                    },
                    {
                        id: "9268157a-12cb-442f-9401-0d88d1846662",
                        image: {
                            src: "assets/images/hassan-kibwana-fmXLB_uHIh4-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "عجّل أراض الواقعة عدد في, طوكيو الأراضي التخطيط الا إذ. قبل ان ليركز مقاطعة. عدم اتّجة الأجل معزّزة ثم. نهاية الإتحاد ومن بـ, تحت أم الشرق، الأثنان الإمتعاض. أم مشروط بمعارضة والنرويج بحق, ان المضي بمعارضة حين. و أمام العظمى عدم, عل فصل نقطة حكومة, قامت تطوير الساحلية كل تلك.",
                        url: "#",
                    },
                    {
                        id: "5113935d-4ed6-4897-a49a-d730de47a973",
                        image: {
                            src: "assets/images/craig-manners-LvJCFOW3Ma8-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "تم خلاف الأسيوي أسر, ضرب ووصف علاقة استبدال عل, وترك إعلان ما أما. التكاليف المشتّتون كل هذا, بعد وباءت الضغوط الثالث قد, و شعار وبريطانيا حدى. فصل ما لفشل جديداً, قد أمام استرجاع بحث. عن مدن تُصب ووصف, تلك أي واُسدل ارتكبها تشيكوسلوفاكيا, ذلك الحرة لمحاكم الأهداف تم. ديسمبر الخاصّة الإثنان أسر أم, يبق ألمّ بالمطالبة أن, تشكيل إتفاقية تلك ثم. و عليها ممثّلة مكثّفة أسر.",
                        url: "#",
                    },
                    {
                        id: "8dbd8d34-edb4-4583-9468-0009d55745c9",
                        image: {
                            src: "assets/images/albert-stoynov-fEdf0fig3os-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "عدد لعدم وفرنسا أي, وتزويده الأرضية يتم هو. جورج مسارح يكن ٣٠. نفس أملاً الشرقي بالولايات مع, تصرّف فرنسية مع الى, ثم الا .",
                        url: "#",
                    },
                    {
                        id: "ec4d93f4-83f7-4427-81fc-b6420d590718",
                        image: {
                            src: "assets/images/ehimetalor-akhere-unuabona-yS0uBoF4xDo-unsplash_448.jpg",
                            alt: "عنصر نائب",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "عجّل الشطر النزاع ثم دنو, ومن عل لفرنسا الباهضة. مئات الأجل واشتدّت بحق كل, غضون وعُرفت نفس أي. انه وحتى أوزار والقرى قد. الخاصّة الأوروبية، من بها, مسرح علاقة الرئيسية ان حين, أن العاصمة ويكيبيديا الا.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-international",
        name: "دولي",
        articles: [
            {
                id: "c5deda28-5da7-4641-80dd-e9859088c95d",
                class: "columns-3-balanced",
                header: "أوروبا",
                type: "articles-list",
                content: [
                    {
                        id: "6a93436c-6c5b-44a7-938e-ebb1f2ee3c15",
                        title: "يرجى المطور في تمويل الجزر طبقة وثيقة الهوية الوحيدة.أنواع نطاق تصنيع الشارع.",
                        content:
                            "الا ان يقوم المشترك بالسيطرة, ثم تسبب وإقامة تغييرات هذا. كان أوسع يتبقّ الكونجرس أي, أسر وجزر بهيئة الأولى كل. أم العناد يتعلّق الخاصّة وصل, بقصف هاربر عدد أن. أي لعدم انتهت الاندونيسية وقد, يتم هو وبدون أملاً الخاطفة. يطول المشترك أن كما. كما وحتّى وقدّموا الوزراء مع, بـ النفط للإتحاد ومن.",
                    },
                    {
                        id: "283ea033-d01a-48a9-b584-635b0b3c8c30",
                        title: "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز",
                        content:
                            "ببعض الوراء بـ حول. فصل هو الأول مهمّات محاولات. حتى عل إحكام الوراء, أن حول بلاده الشمل المدن, وقام شاسعة واستمرت ٣٠ قبل. بحث بتطويق بمباركة الشتوية ما, عُقر معزّزة أن حيث. مع ضرب حاول جسيمة علاقة. حدى في تعداد الآخر. أسر تم أعلنت القادة, تم لها معاملة الهادي.",
                    },
                    {
                        id: "5670b9e0-4b99-48d5-8b31-525ae350de32",
                        title: "ولكن إذا كانت حمامات كرة القدم ، ولكن البحيرة ، ولكن الكاريكاتير في.",
                        content:
                            "حول عل الجنود الشتاء،, لها عليها بتخصيص الجنرال كل. نتيجة الشمل كل لها. الا بـ وبدون الإنزال بالمطالبة, حول لم هناك الإمداد. تحرّك بالعمل هو بين, عل على وسوء بزمام اليها. ٣٠ جعل تعداد وباءت وقوعها،, نتيجة أعلنت مشاركة بها تم, احداث والديون قام أي.",
                    },
                ],
            },
            {
                id: "387033b0-e832-48b3-a3fe-f104075cf93a",
                class: "columns-3-balanced",
                header: "أمريكا الجنوبية",
                type: "articles-list",
                content: [
                    {
                        id: "ace185f1-1e8a-4db5-9266-95412f7b06ff",
                        title: "كانت دعاية الحاجة القوس متنوعة الواجب المنزلي.",
                        content:
                            "وفي مكّن للسيطرة الإطلاق من. في وصل جسيمة المتحدة التجارية, عن ضرب الإمداد ولكسمبورغ, هو بالفشل والعتاد أضف. فبعد وعُرفت إنطلاق في ومن. وترك وبولندا بعض مع, للسيطرة العسكري الأوروبي مدن أن. بـ الجنود الأثناء، لبولندا، كان, مكن عن تحرّكت استطاعوا.",
                    },
                    {
                        id: "3a4170ea-bd6f-4de9-94e9-7f487d68e1eb",
                        title: "طريقة لوريم إيبسوم لأنها تعطي توزيعاَ طبيعياَ -إلى حد ما- للأحرف عوضاً عن استخدام هنا يوجد",
                        content:
                            "دون ثم بداية حادثة ويكيبيديا. أما لهيمنة استبدال التكاليف عل, أي تحت جدول وبداية اتفاقية. عرض ما تمهيد مسارح وحلفاؤها, ان أثره، فشكّل مدن. صفحة لغات مشارف بل مدن, دون تم الجنود المبرمة. الذود بأضرار الأهداف انه أي, بالعمل وصافرات ومن تم, مئات مشروط بال من.",
                    },
                    {
                        id: "b5b51051-9b1c-496b-8390-432802b4e1e7",
                        title: "يشرب أو تريد كل منها.",
                        content: "فعل يونيو انتصارهم في, و أخر تعداد أوزار ليرتفع. لم حتى جسيمة وسمّيت والإتحاد. بفرض الصفحات لم لان, جسيمة السفن يكن كل. أن الفترة بريطانيا مدن.",
                    },
                ],
            },
            {
                id: "06fa8c40-6678-483b-bbb5-a8f73822d1e1",
                class: "columns-3-balanced",
                header: "آسيا",
                type: "articles-list",
                content: [
                    {
                        id: "3654e18a-e633-4774-899a-7517b2ff28c7",
                        title: "قد يكون الأعضاء أيضًا لاعبيك الفلفل الحار.على سبيل المثال ، ولكن حلق القبيح في كرة القدم ، مشروب بلدي ، ولا.",
                        content:
                            "الشمال سليمان، ان دول, قد ومضى وقبل عشوائية لمّ. البرية والعتاد وصل من, أن شيء وبدأت حالية. أم كما واحدة اتفاقية, أي بحق أراضي واقتصار. ثم وجزر تكاليف عشوائية الى, عل ولم سكان قائمة. ان حين رئيس مرمى وترك. نفس إعلان واتّجه سنغافورة ٣٠, المبرمة ماليزيا، قد إيو. بـ وقد وجزر قادة لبولندا،, تحت عل الثقيل الربيع،.",
                    },
                    {
                        id: "3461de32-20f7-4787-b31c-4c1b08b9e02b",
                        title: "وادي هاريترا لتعيين وعاء الأسد الذي يرجع تاريخه.",
                        content:
                            "حتى لم جورج عليها استدعى, جديدة وباءت الساحة ان كما, يبق عن فبعد والنفيس الاندونيسية. يكن بـ يتبقّ تغييرات, عدد بسبب علاقة الدّفاع إذ. أن رجوعهم اسبوعين جعل, أكثر مقاومة في بال. و مساعدة وتزويده العالمية لان, بحث خيار مساعدة عل, من بها بالفشل وإعلان مواقعها. سقطت مساعدة بين أي, أعلنت استرجاع بعد ثم.",
                    },
                    {
                        id: "3fe9e8db-160b-4a2d-b586-33cce8f4c3fa",
                        title: "في مختلف أو جعبة أو قبيح بحاجة الآن إلى ألم لوريم.",
                        content: "رجوعهم الجنوب أي بحث. بل مرجع وصغار شيء, بسبب جديدة دول بل. ان لإعادة المجتمع وايرلندا بال, مكن و يعبأ محاولات ومطالبة. جهة أم مايو سياسة الدمج. حول سبتمبر وبغطاء ومحاولة بل, فعل أي بلديهما لتقليعة للأراضي.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-featured",
        name: "متميز",
        articles: [
            {
                id: "f0704a5e-cf35-4c2b-afc1-c07325577554",
                class: "columns-3-balanced",
                header: "واشنطن",
                image: {
                    src: "assets/images/heidi-kaden-L_U4jhwZ6hY-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "عشوائي أخذتها من نص، لتكوّن كتيّب بمثابة دليل أو مرجع شكلي لهذه الأحرف. خمسة قرون من",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "e82d88ff-6406-4f82-8d8a-3c0939cda3ba",
                        content: "تدليك كرة القدم الجذاب في الجبهة.",
                        url: "#",
                    },
                    {
                        id: "0dc64ba7-dc5b-4cb4-b729-fbee531ae382",
                        content: "اضبط الجري القبيح في هذا الشارع العشور.",
                        url: "#",
                    },
                    {
                        id: "8a54f7e2-3aec-4e91-a029-9b9fe2a9bf07",
                        content: "وفي مكّن للسيطرة الإطلاق من. في وصل جسيمة المتحدة التجارية, عن",
                        url: "#",
                    },
                    {
                        id: "337cf7d7-0cbf-4a6f-ba8d-f5ab56f542af",
                        content: "الأداء على مجموعة الموجات فوق الصوتية للواجبات العقارية التغذوية حتى الآن.",
                        url: "#",
                    },
                    {
                        id: "b93dfad8-0ad4-4825-bdf2-b9a6c77ed21a",
                        content: "من تصحيح فكي التدليك في بعض الأحيان.",
                        url: "#",
                    },
                    {
                        id: "28b3b72d-55c5-4f42-b51b-c6c5fffc506d",
                        content: "الكثير من الضعف من أجل عدم وجود ضغوط طيران الموز.",
                        url: "#",
                    },
                ],
            },
            {
                id: "9f57970b-05f9-45c2-9e3c-ab0f66ce47f3",
                class: "columns-3-balanced",
                header: "نيويورك",
                image: {
                    src: "assets/images/hannah-busing-0V6DmTuJaIk-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الزمن لم تقضي على هذا النص، بل انه حتى صار مستخدماً وبشكله الأصلي في الطباعة والتنضيد",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "36576fce-6f70-4b2f-b635-d586a51b3a9b",
                        content: "هذه دائمًا ابتسامة في المكياج حامل المكتب ليس الجميع كذلك.",
                        url: "#",
                    },
                    {
                        id: "efd66d67-6a81-46be-b682-6dfa7b5895df",
                        content: "وعُرفت إنطلاق في ومن. وترك وبولندا بعض مع, للسيطرة العسكر",
                        url: "#",
                    },
                    {
                        id: "1390fee3-5d9b-468c-8d95-9c04943a3561",
                        content: "دون ثم بداية حادثة ويكيبيديا. أما لهيمنة استبدال التكاليف عل, أي تحت ",
                        url: "#",
                    },
                    {
                        id: "a2f63129-54de-4003-8070-42dbba2c1bfd",
                        content: "فعل يونيو انتصارهم في, و أخر تعداد أوزار ليرتفع. لم حتى جسي",
                        url: "#",
                    },
                    {
                        id: "9eec6eb8-c67e-4b57-8e7e-fe4a71dbae2b",
                        content: "الشمال سليمان، ان دول, قد ومضى وقبل عشوائية لمّ. البرية والعتاد وصل",
                        url: "#",
                    },
                    {
                        id: "677e1086-aef8-4561-8ecb-af75a7c82f6f",
                        content: "الكثير من الكتلة من صلصة ماكرو الحياة.",
                        url: "#",
                    },
                ],
            },
            {
                id: "bda30bf1-8032-4bfa-b17d-07571a7251f7",
                class: "columns-3-balanced",
                header: "الملائكة",
                image: {
                    src: "assets/images/martin-jernberg-jVNWCFwdjZU-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "يولد المورس لتفوت الماوس.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "51427dca-f312-4cc7-b7b2-719bf4c5cd8a",
                        content: "ماتيس هو السخرية من الأسهم العناصر.",
                        url: "#",
                    },
                    {
                        id: "6f3ae21d-312b-4065-8af1-04719f6d3160",
                        content: "الجزر المعقمة وعاء الجري تحتاج الآن كرتون الشوكولاتة موريس.",
                        url: "#",
                    },
                    {
                        id: "352dec10-0863-4244-a60b-002e40022c94",
                        content: "حتى لم جورج عليها استدعى, جديدة و",
                        url: "#",
                    },
                    {
                        id: "e31c2cc9-5f99-4a01-84cf-587dcf47be7e",
                        content: "الآن كرتون الشوكولاتة موريس في بعض.",
                        url: "#",
                    },
                    {
                        id: "9c041d54-ea0b-4a63-877b-a793f1b84297",
                        content: "تريد التمويل ولكن الأداء ولكن بوابة لوريم لينة بعض.",
                        url: "#",
                    },
                    {
                        id: "a31a24a9-708a-4227-9038-bd14a0a7c7b1",
                        content: "المبرمة ماليزيا، قد إيو. بـ وقد وجزر قادة لبولندا،, تحت عل الثقيل الربيع،.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-underscored",
        name: "يؤكد",
        articles: [
            {
                id: "affd2923-97de-4410-9258-bce3e4a19b87",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "92946ccb-022d-4319-be94-49e476c31077",
                        image: {
                            src: "assets/images/kevin-wang-t7vEVxwGGm0-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "تصفح يقوم الشهير عدد و. و وتم بوابة تطوير. إيو قد لعدم يعادل, ذلك لدحر وتنامت كل, قام وسوء أملاً المشتّتون في. بعد يذكر نتيجة اليابان، كل, أحدث أطراف البولندي كان أن. ذات لهيمنة الحدود و, أسابيع الحدود اليابانية ان حتى. دون مارد أجزاء المؤلّفة ٣٠.",
                        url: "#",
                    },
                    {
                        id: "419ea32d-d12e-4c2b-9a14-fee91ba7ee7f",
                        image: {
                            src: "assets/images/claudio-schwarz-3cWxxW2ggKE-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "وتم بقيادة الواقعة باستحداث ما, أي انه العدّ ممثّلة استدعى. إيو ان وقرى لغزو, فكانت الشطر شموليةً يكن لم. دفّة الأخذ جهة ٣٠, مع بسبب بالفشل حين. أن والحزب والمانيا ضرب, لدحر التي إذ أخر, بين لم وقرى بهيئة. وجزر بالفشل الأوروبيّون قام أي, بل والتي التخطيط تحت.",
                        url: "#",
                    },
                ],
            },
            {
                id: "a196957d-d9fa-400a-a94c-dca3f6815700",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "4e31cef9-8787-437c-ae06-9e5654f540d9",
                        image: {
                            src: "assets/images/braden-collum-9HI8UJMSdZA-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "وعلى أفاق مهمّات من أما. أخذ ضمنها انتهت أفريقيا ان. في ا استمرار الدنمارك ذات, ما بينما معزّزة الا. قِبل وباءت والعتاد ان فعل, ٣٠ ومن وقبل بتخصيص. على حصدت ليبين تكاليف أم, بلا من حكومة الشرق،, لان لإعادة الثقيلة في. بين وبعض حكومة إعادة من, جنوب النفط ٣٠ على.",
                        url: "#",
                    },
                    {
                        id: "292cc517-c2d8-4941-acf3-bfe9a33cea58",
                        image: {
                            src: "assets/images/geoff-scott-8lUTnkZXZSA-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "وتم عُقر النفط الرئيسية عن, ضمنها ولكسمبورغ وبريطانيا ثم مما. ولم أم أكثر وبالتحديد،, عرض الحرة الطرفين اتفاقية إذ, لغزو التجارية التقليدية عل جعل. أي مدن غينيا وسمّيت, إبّان فرنسا أي فقد, على مع سليمان، والإتحاد بريطانيا-فرنسا. أي الإثنان العمليات جُل, ان سابق معاملة حيث. سكان تشكيل بقيادة هو دنو.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-happening-now",
        name: "يحدث الآن",
        articles: [
            {
                id: "f07e6f59-5962-4410-b1a1-493770fa85c6",
                class: "columns-wrap",
                header: "سياسي",
                type: "excerpt",
                content: [
                    {
                        id: "501331da-4f36-4a63-8e37-78fbc84d7485",
                        image: {
                            src: "assets/images/jonathan-simcoe-S9J1HqoL9ns-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "كنقطة الانجليزية كل حين, ٣٠ الجنوبي ايطاليا، التغييرات انه, عل هذه إنطلاق البرية. هُزم الفرنسي الأمريكية ٣٠ عدد, دون ما منتصف أوروبا بالإنزال. ٣٠ تحرّك الفرنسي فصل, بل كما ا البولندي. نهاية بالمحور حدى إذ, إذ أوسع تجهيز الشمال ذات, قد بلا الحكومة الواقعة الكونجرس. أم فقد وبدون المحيط. ومن بل قدما الشرق، الأمريكي, ٣٠ أواخر تشكيل وانهاء على.",
                    },
                    {
                        id: "72c9a293-beba-4604-8a5b-ae6ec5dbdcf0",
                        image: {
                            src: "assets/images/markus-spiske-p2Xor4Lbrrk-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "كل يعبأ بالرّد الولايات فعل, بلاده وباستثناء الإتفاقية قد على, أحكم لإعادة في تحت. جسيمة جديداً بالسيطرة ثم كان, بل يقوم وجهان واستمر وصل. ووصف واعتلاء و حيث, فقامت المحيط لتقليعة كان بـ. قدما جديداً إيطاليا بلا إذ, قد بأيدي الشرقي أسر. حول تم تحرير الثقيلة. تصرّف شاسعة مع عدم, أم العاصمة الشرقية المعاهدات به،.",
                    },
                    {
                        id: "505495bc-4141-4277-aba5-08cecdb0f52c",
                        image: {
                            src: "assets/images/marius-oprea-ySA9uj7zSmw-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ذات لم فكان فقامت والروسية. لمّ هُزم انتباه بل. دون مع لعدم ويتّفق المواد. كرسي اتّجة أطراف كلا من, بشرية وايرلندا كان ٣٠. ٣٠ وسفن قُدُماً الإيطالية بين, كل النفط يعادل هذا.",
                    },
                ],
            },
            {
                id: "3c3b206d-1b03-4fcc-9469-25b2caa64622",
                class: "columns-wrap",
                header: "صحة",
                type: "excerpt",
                content: [
                    {
                        id: "ce276359-8308-4af0-8d6f-c9141503f972",
                        image: {
                            src: "assets/images/jannis-brandt-mmsQUgMLqUo-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ما جُل هنا؟ وأكثرها, عن انه جزيرتي بالمطالبة. الله حقول كان في, بـ إيو ألمّ أخرى والمعدات, أخر بل تحرّك الضغوط والمانيا. ما سقوط نتيجة ويتّفق ومن. وفي ودول الواقعة ان, ٣٠ ذلك يذكر المتساقطة،, نفس و بقيادة بالحرب. بحث الأخذ وانهاء في, بالحرب وإيطالي لكل من.",
                    },
                    {
                        id: "e3a10fed-2a09-4821-aad0-b8af9f906769",
                        image: {
                            src: "assets/images/martha-dominguez-de-gouveia-k-NnVZ-z26w-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "فكانت اعلان وإقامة قد وصل, ان يذكر قبضتهم والفلبين مكن. هو فقد وكسبت العصبة استبدال. أن الطرفين استراليا، انه. كانتا اكتوبر ان قبل, بقيادة وبولندا بريطانيا-فرنسا ما بين, عن أما لهيمنة والمانيا ماليزيا،. مع يبق بفرض وتنامت واستمرت, مع سياسة جديداً ذلك.",
                    },
                    {
                        id: "3676e79b-88d4-454c-ae72-32e3f38b869f",
                        image: {
                            src: "assets/images/freestocks-nss2eRzQwgw-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "هامش البرية الساحلية دنو في, مع شاسعة تعديل ومطالبة على. أي تمهيد عليها والكساد دول, أم ذات رئيس وصافرات. دار مرجع الأوروبية، قد, أملاً واُسدل حاملات أم بحث. من بشرية قُدُماً جُل, بها كل سياسة فقامت وانهاء. الستار للحكومة عل مدن, مشروط كُلفة المسرح من يكن, تحت بـ الجو وتتحمّل لبلجيكا،. غضون لفشل تحرّك ما جعل. حيث في قررت وباءت, قبل ثم الآخر بالفشل معزّزة, قد ترتيب استراليا، مكن.",
                    },
                ],
            },
            {
                id: "19a7a320-69b7-4ac6-b2b1-17206ccc8e67",
                class: "columns-wrap",
                header: "عمل",
                type: "excerpt",
                content: [
                    {
                        id: "8431d24b-4967-4434-b165-18af09cbfe81",
                        image: {
                            src: "assets/images/little-plant-TZw891-oMio-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "حيث عل وقرى بمباركة. لم بعض أمام ولاتّساع, العناد بمعارضة الإمتعاض تلك ما. ثم تمهيد كثيرة الشّعبين ذات, بـ كرسي أصقاع واتّجه لان, بقعة كانت الحرة كان و. مدن وزارة ميناء بمعارضة مع, جديداً تحرّكت باستخدام قد يتم.",
                    },
                    {
                        id: "50fa2776-bff8-42c7-a0ea-883cf40e66cf",
                        image: {
                            src: "assets/images/allan-wadsworth-Lp78NT-mf9o-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بها لم تونس جديدة الدّفاع, تم وصل مارد إجلاء اعلان. يبق في هامش المؤلّفة الدولارات, أم انه مليارات ولاتّساع الكونجرس. ترتيب الأخذ ممثّلة أسر ثم, الشمل الجنود عن كلا. وفنلندا الإثنان الجنوبي ثم حيث. وبعد لليابان ثم بعد. لم يكن الساحل التكاليف, حدى أجزاء الحيلولة عن, وأزيز مقاطعة الفرنسية كلا و. يعادل وإعلان واقتصار دول و.",
                    },
                    {
                        id: "f9099723-cd63-4158-906e-d9bf33904156",
                        image: {
                            src: "assets/images/ant-rozetsky-SLIFI67jv5k-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "سقوط إحكام وبولندا أم جعل, جُل بـ فسقط تطوير سليمان،, وقرى الأجل الأوضاع ذلك ثم. أوسع الدنمارك ان أخر. العالمي مواقعها بال إذ, أما المحيط الاندونيسية هو. بل أخذ أواخر الآلاف القادة, أم استرجاع والنرويج غير, استدعى العالم، الأوربيين قد شيء. وجهان الدول وإعلان أما أم, ان رئيس مسارح اعلان يتم. تلك تُصب والنفيس هو, ماشاء الإثنان المتساقطة، عن شيء.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-hot-topics",
        name: "مواضيع مثيرة",
        articles: [
            {
                id: "514e6188-22a4-4d01-ac19-342df74680e7",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "79d06fe0-30a7-41b8-b318-1aca53454296",
                        image: {
                            src: "assets/images/alexandre-debieve-FO7JIlwjOtU-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "مع يبق المضي العالمية, كلّ هو جورج الآخر الغالي. انه ومضى القوى أي. كل غريمه بالمطالبة دول, بـ كلا قررت وعُرفت قُدُماً. نتيجة الشهيرة والفرنسي عدد كل, عدم ان وجزر وبدأت. بزمام الحيلولة بـ عرض, الى عُقر أفاق بالجانب هو, مكن أي تصفح التحالف. بال منتصف المؤلّفة قد, وقد وحلفاؤها المشتّتون أي.",
                        url: "#",
                    },
                    {
                        id: "6c9f3533-ab33-4099-a38c-f2841d7ca278",
                        image: {
                            src: "assets/images/thisisengineering-ZPeXrWxOjRQ-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "أي حدى بزمام العالم, المسرح الأبرياء في لها. ٣٠ ولم بخطوط تشكيل اعتداء, أم الوزراء التقليدي التقليدية دون. من بسبب العالمي كلا, ان يونيو التقليدي حول. كان أسيا وباءت واُسدل إذ, قتيل، شواطيء وتم من.",
                        url: "#",
                    },
                ],
            },
            {
                id: "df35d241-7b4e-41af-b4a8-aa5ac86a2625",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "16d97cdf-e13a-4470-8d7b-70ef8a0d6542",
                        image: {
                            src: "assets/images/isaw-company-Oqv_bQbZgS8-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "دنو صفحة أصقاع والكساد بل. بها ليبين بالولايات من, تعد أملاً وهولندا، ويكيبيديا، ان. كل أضف قِبل وبحلول استبدال, في الوراء للمجهود تلك. وبعض اعلان معاملة حول هو, مسؤولية الثانية في جهة. بها الوراء التّحول الأوروبية، في. الإنزال التّحول جُل من, مكّن مليون العدّ ٣٠ لان.",
                        url: "#",
                    },
                    {
                        id: "26c3b788-742a-4b7a-824e-91db371e5083",
                        image: {
                            src: "assets/images/aditya-chinchure-ZhQCZjr9fHo-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "دون قد بخطوط الشهير, قد يقوم الهادي والروسية جهة, أدنى الإطلاق الانجليزية عن تحت. بعد مسؤولية ارتكبها ان, لها العصبة المشتّتون بـ, أخرى وتزويده جُل ما. كل سقطت الصفحة وفنلندا إيو, حصدت اعلان وتنامت أم لمّ. وقد بحشد سقوط عليها في, عل تطوير للجزر المشترك فصل. ذات ٣٠ السفن اسبوعين.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-paid-content",
        name: "المحتوى المدفوع",
        articles: [
            {
                id: "694bbfce-f1c9-4e10-95bc-a89023d5e1ea",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "39a82f01-b2fc-4740-a5ca-f1ada041100a",
                        image: {
                            src: "assets/images/tamara-bellis-IwVRO3TLjLc-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "الآن يشرب الموز لمضادات الأكسدة الحوامل أو.ولا  في الخميرة وضعت على الوعاء.م",
                    },
                    {
                        id: "8a50960e-fbde-4705-bc6a-76865f78ec50",
                        image: {
                            src: "assets/images/david-lezcano-NfZiOJzZgcg-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "تحتاج إلى كرة قدم ذكية أو قوس ابتسامة أي شخص.لا الدردشة القوس الحامل وأصول درجة الحرارة.",
                    },
                ],
            },
            {
                id: "6e110ab5-5d43-411b-a64e-3dae38960a60",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "9728082f-7e27-4366-8bf4-dbd74f13daf8",
                        image: {
                            src: "assets/images/heidi-fin-2TLREZi7BUg-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "من رقعة من فكي التدليك في بعض الأحيان.مجموعة التغذية الجماعية للعقارات التجمعات فوق الصوتيات حتى الآن.وادي الغد هو دائما المؤلف أو فترة الحياة.لارتجال الكثير من بعض المعرف.",
                    },
                    {
                        id: "216eaa21-8a0f-4baf-8dc3-103391d77002",
                        image: {
                            src: "assets/images/joshua-rawson-harris-YNaSz-E7Qss-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "البيئي لا يحتاج إلى قطر كرة القدم حتى.كرة القد وصفة شبكة.",
                    },
                ],
            },
            {
                id: "e72adfa5-f82e-42b3-a0c6-c43f0c3f9393",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "848a8767-90da-4ff1-a2b1-293def11434f",
                        image: {
                            src: "assets/images/arturo-rey-5yP83RhaFGA-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "أو حامل.لا يوجد مركبة من موبيليسي نولام نفسها من مسار طيران أو بعض كرة القدم.أي شخص هو شوكولاتة كرتون.",
                    },
                    {
                        id: "f9c3995e-c12d-47ef-89e6-efb535d7678a",
                        image: {
                            src: "assets/images/clem-onojeghuo-RLJnH4Mt9A0-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "هنالك العديد من الأنواع المتوفرة لنصوص لوريم إيبسوم، ولكن الغالبية تم تعديلها بشكل ما عبر",
                    },
                ],
            },
            {
                id: "96bc6b53-c533-4970-adb7-8dae30da76cc",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "15d8615d-52c0-4aa5-a0d0-2eb20c6c0675",
                        image: {
                            src: "assets/images/ashim-d-silva-ZmgJiztRHXE-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "عليك أن تتحقق أولاً أن ليس هناك أي كلمات أو عبارات محرجة أو غير لائقة مخبأة في هذا النص.",
                    },
                    {
                        id: "75a08ef8-8177-4047-bb40-3448c0169cd9",
                        image: {
                            src: "assets/images/toa-heftiba--abWByT3yg4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "طبقة ناعمة من أسد العبارة من قطر.الآن يشرب الموز لمضادات الأكسدة الحوامل أو الوادي.",
                    },
                ],
            },
        ],
    },
];
